// extracted by mini-css-extract-plugin
export default {"field":"SignUp_field__G8eat","input":"SignUp_input__tft6b","checkbox":"SignUp_checkbox__ZQbSl","createBtn":"SignUp_createBtn__76Dca","productName":"SignUp_productName__l9--O"};